import React from 'react'
import { useMobileLoginOptions } from '@providers/mobile-login-options'
import { usePopupMenu } from '@providers/mobile-popup-menu'
import { MenuOwnProps } from '@shared/components/page-layout/model'
import { useScreenSize } from '@shared/hooks/use-screen-size'
import { useWindowSize } from '@shared/hooks/use-window-size'

import { View } from './view'

export const TopMenu = ({ EndAdornment, content, isLogoHidden, hideLinksList }: MenuOwnProps) => {
	const popupMenu = usePopupMenu()
	const screenSize = useScreenSize()
	const { width } = useWindowSize()
	const mobileLoginOptions = useMobileLoginOptions()

	return View({
		screenSize,
		isLogoHidden,
		EndAdornment,
		width,
		content,
		onOpenPopupMenu: () => popupMenu.setVisibleStatus(true),
		onShowMobileLoginOptions: mobileLoginOptions.show,
		hideLinksList,
	})
}
